// メインビジュアルのアニメーション===============
document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const layoutIndicator = document.getElementById("layout-number");
  let currentLayout = 1; // 初期レイアウトを1に固定
  const totalLayouts = 5;
  let animationInProgress = false;
  let layoutInterval;

  // .fv-special2025が存在する場合のみ発火-------
  if (document.querySelector(".fv-special2025")) {
    // 初期レイアウトを1に設定
    body.classList.add(`kvLayout--${currentLayout}`);

    // layout-indicatorが存在する場合のみテキストを設定
    if (layoutIndicator) {
      layoutIndicator.textContent = currentLayout;
    }

    // ブロックに指定された写真を適用
    const blocks = document.querySelectorAll(".castBlock");
    const photoData = [
      { img: "fv_AKEEM.jpg", link: "/pages/interview_AKEEM" },
      { img: "fv_AssH.jpg", link: "/pages/interview_AssH" },
      { img: "fv_famshiba.jpg", link: "/pages/interview_famshiba" },
      { img: "fv_Hanabi.jpg", link: "/pages/interview_Hanabi" },
      { img: "fv_MANA.jpg", link: "/pages/interview_MANA" },
      {
        img: "fv_MasayaYamagishi.jpg",
        link: "/pages/interview_MasayaYamagishi",
      },
      { img: "fv_Misaki.jpg", link: "/pages/interview_Misaki" },
      { img: "fv_sarA.jpg", link: "/pages/interview_sarA" },
      { img: "fv_uki.jpg", link: "/pages/interview_uki" },
      { img: "fv_Vinih.jpg", link: "/pages/interview_Vinih" },
    ];

    // 各ブロックに異なる画像を適用するため、写真をシャッフルして使用する
    function shuffleArray(array) {
      const shuffled = [...array]; // 配列をコピー
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    }

    // 写真配列をシャッフル
    let shuffledPhotoData = shuffleArray(photoData);

    // 表示可能なブロックを取得（初期表示時はすべて表示可能）
    const visibleBlocks = [...blocks].filter(
      (block) =>
        getComputedStyle(block).visibility !== "hidden" ||
        (!body.classList.contains("kvLayout--4") &&
          !body.classList.contains("kvLayout--5"))
    );

    // 表示可能なブロックの数が写真の数より多い場合、写真を複製して足りるようにする
    if (visibleBlocks.length > photoData.length) {
      // 必要な数になるまで写真を追加（重複がないようにシャッフルしながら）
      while (shuffledPhotoData.length < visibleBlocks.length) {
        const additionalPhotos = shuffleArray([...photoData]);
        // 連続して同じ写真が来ないように確認
        if (shuffledPhotoData.length > 0) {
          let lastPhoto = shuffledPhotoData[shuffledPhotoData.length - 1].img;
          if (lastPhoto === additionalPhotos[0].img) {
            // 先頭の写真が前の最後の写真と同じなら入れ替え
            [additionalPhotos[0], additionalPhotos[1]] = [
              additionalPhotos[1],
              additionalPhotos[0],
            ];
          }
        }
        shuffledPhotoData = [...shuffledPhotoData, ...additionalPhotos];
      }
      // 必要な数に切り詰め
      shuffledPhotoData = shuffledPhotoData.slice(0, visibleBlocks.length);
    }

    // 各表示可能なブロックに順番に異なる写真とリンクを適用
    visibleBlocks.forEach((block, index) => {
      const img = block.querySelector(".castThum__img");
      const link = block.querySelector(".castBlock__link");

      // nullチェックを追加して、要素が存在する場合のみスタイルを適用
      if (img && link) {
        const photoInfo = shuffledPhotoData[index];

        // 画像URLを設定
        img.style.backgroundImage = `url('/cdn/shop/files/${photoInfo.img}')`;

        // リンクURLを設定
        link.href = photoInfo.link;

        // ブロック名を画像名から抽出して設定 (オプション)
        const nameElement = block.querySelector(
          ".listBlock__loversName--tate--p"
        );
        if (nameElement) {
          // fv_から.jpgまでの間の文字列を抽出
          const name = photoInfo.img.replace("fv_", "").replace(".jpg", "");
          nameElement.textContent = name;
        }
      }
    });

    // すべてのブロックを非表示にする関数
    function hideAllBlocks() {
      blocks.forEach((block) => {
        block.style.opacity = 0;
        block.style.transition = "opacity 0.3s ease-out";
      });
    }

    // ブロックをランダムな順序で表示する関数
    function showBlocksSequentially(layout) {
      // 表示可能なブロックを取得
      const visibleBlocks = [...blocks].filter(
        (block) => getComputedStyle(block).visibility !== "hidden"
      );

      // ブロックをランダムな順序で表示するためシャッフル
      const shuffledBlocks = shuffleArray([...visibleBlocks]);

      // ブロックを1つずつランダムな順序で表示
      let visibleCount = 0;
      shuffledBlocks.forEach((block, index) => {
        visibleCount++;
        setTimeout(() => {
          block.style.opacity = 1;
          block.style.transition = "opacity 0.3s ease-in";
        }, 150 * index);
      });

      // 最後の表示ブロックの後にアニメーション完了としてマーク
      setTimeout(() => {
        animationInProgress = false;
      }, 150 * visibleCount + 300); // 最後のトランジション用に300ms追加
    }

    // テキスト画像のランダム表示関数
    function changeTextImage() {
      const textImages = document.querySelectorAll(".kvText__img");
      if (textImages.length === 0) return; // 画像が存在しない場合は何もしない

      // まず全ての画像を非アクティブにする
      textImages.forEach((img) => {
        img.classList.remove("kvText__img--active");
      });

      // ランダムに1つの画像を選んでアクティブにする
      const randomIndex = Math.floor(Math.random() * textImages.length);
      textImages[randomIndex].classList.add("kvText__img--active");
    }

    // レイアウトをランダムに変更する関数
    function changeLayout() {
      if (animationInProgress) return;

      animationInProgress = true;
      // console.log("レイアウト変更中:", currentLayout);

      // まずすべてのブロックを非表示に
      hideAllBlocks();

      // テキスト画像も変更
      changeTextImage();

      setTimeout(() => {
        // 現在のレイアウトクラスを削除
        body.classList.remove(`kvLayout--${currentLayout}`);

        // ランダムに新しいレイアウトを選択（現在と異なるレイアウト）
        let newLayout;
        do {
          newLayout = Math.floor(Math.random() * totalLayouts) + 1;
        } while (newLayout === currentLayout);

        currentLayout = newLayout;
        // console.log("新しいレイアウト:", currentLayout);

        // 新しいレイアウトクラスを追加
        body.classList.add(`kvLayout--${currentLayout}`);

        // layout-indicatorが存在する場合のみテキストを設定
        if (layoutIndicator) {
          layoutIndicator.textContent = currentLayout;
        }

        // 写真を再シャッフル
        let shuffledPhotoData = shuffleArray([...photoData]);

        // 表示可能なブロックを取得
        const visibleBlocks = [...blocks].filter(
          (block) => getComputedStyle(block).visibility !== "hidden"
        );

        // 表示可能なブロックの数が写真の数より多い場合、写真を複製して足りるようにする
        if (visibleBlocks.length > photoData.length) {
          // 必要な数になるまで写真を追加（重複がないようにシャッフルしながら）
          while (shuffledPhotoData.length < visibleBlocks.length) {
            const additionalPhotos = shuffleArray([...photoData]);
            // 連続して同じ写真が来ないように確認
            let lastPhoto = shuffledPhotoData[shuffledPhotoData.length - 1].img;
            if (lastPhoto === additionalPhotos[0].img) {
              // 先頭の写真が前の最後の写真と同じなら入れ替え
              [additionalPhotos[0], additionalPhotos[1]] = [
                additionalPhotos[1],
                additionalPhotos[0],
              ];
            }
            shuffledPhotoData = [...shuffledPhotoData, ...additionalPhotos];
          }
          // 必要な数に切り詰め
          shuffledPhotoData = shuffledPhotoData.slice(0, visibleBlocks.length);
        }

        // 各表示可能なブロックに順番に異なる写真とリンクを適用
        visibleBlocks.forEach((block, index) => {
          const img = block.querySelector(".castThum__img");
          const link = block.querySelector(".castBlock__link");

          // nullチェックを追加して、要素が存在する場合のみスタイルを適用
          if (img && link) {
            const photoInfo = shuffledPhotoData[index];

            // 画像URLを設定
            img.style.backgroundImage = `url('/cdn/shop/files/${photoInfo.img}')`;

            // リンクURLを設定
            link.href = photoInfo.link;

            // ブロック名を画像名から抽出して設定 (オプション)
            const nameElement = block.querySelector(
              ".listBlock__loversName--tate--p"
            );
            if (nameElement) {
              // fv_から.jpgまでの間の文字列を抽出
              const name = photoInfo.img.replace("fv_", "").replace(".jpg", "");
              nameElement.textContent = name;
            }
          }
        });

        // ブロックを順番に表示
        showBlocksSequentially(currentLayout);
      }, 500); // すべてのブロックがフェードアウトするまで待機
    }

    // 5秒ごとにレイアウトを変更する間隔を設定（無限ループ）
    function startLayoutInterval() {
      // 重複を防ぐために既存の間隔をクリア
      if (layoutInterval) {
        clearInterval(layoutInterval);
      }
      layoutInterval = setInterval(() => {
        // console.log("インターバル発動、現在のレイアウト:", currentLayout);
        changeLayout();
      }, 5000);
    }

    // 自動レイアウト変更を開始
    startLayoutInterval();

    // テスト用にクリックでレイアウト変更を許可
    document.querySelector(".kvBg").addEventListener("click", function () {
      if (!animationInProgress) {
        // 既存の間隔をクリア
        clearInterval(layoutInterval);

        // すぐにレイアウトを変更
        changeLayout();

        // 間隔を再開
        startLayoutInterval();
      }
    });

    // ウィンドウリサイズを処理
    window.addEventListener("resize", function () {
      // ウィンドウサイズ変更時に必要に応じて要素を調整
      // パーセンテージベースのレイアウトは自動的に維持される
    });

    // 初期表示 - ブロックを順番に表示
    blocks.forEach((block) => {
      block.style.opacity = 0;
    });

    // 初期テキスト画像をランダムに1つ選択
    changeTextImage();

    setTimeout(() => {
      showBlocksSequentially(currentLayout);
    }, 500);
  }
});

// Swiper==========================
document.addEventListener("DOMContentLoaded", function () {
  // Swiperの初期化（Gallery）------------------------
  const swiperGallery = new Swiper(".js-swiper--special2025", {
    // Swiperのオプションを設定===========
    slidesPerView: 1.4, // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）。アクティブスライド以外のスライドを少し見せたい場合は、値を小数点にする。
    spaceBetween: 0, // スライド間の余白（px、%の場合は"20%"で囲む）
    centeredSlides: true, // アクティブなスライドを中央に配置する
    loop: true, // スライドをループさせるかどうか
    speed: 10000, // スライドのスピード（ms）
    breakpoints: {
      500: {
        //500px以上
        slidesPerView: 2.5,
        // spaceBetween: "4.6%", // スライド間の余白（px、%の場合は"20%"で囲む）
        // centeredSlides: false, // アクティブなスライドを中央に配置する
      },
      769: {
        //769px以上
        slidesPerView: 4,
      },
      1600: {
        //1000px以上
        slidesPerView: 5,
      },
    },
    // 自動再生
    autoplay: {
      delay: 0, // 自動再生の間隔（ms）
      disableOnInteraction: false, // ユーザーの操作後も自動再生を継続する
    },
    // 必要ならスクロールバーを入れる
    scrollbar: {
      el: ".swiper-scrollbar--special2025",
      hide: false, //スライドを動かす時だけ表示させたい時、trueにする
    },
  });
});

//-----------------------------
//追従ボタン、headerのスクロールアニメーション
document.addEventListener("DOMContentLoaded", function () {
  // 追従ボタン
  const special2025FixedElements = document.querySelectorAll(
    ".js-special2025-fixed"
  );
  //   // ヘッダー
  //   const special2025HeaderElements = document.querySelectorAll(
  //     ".js-special2025-header"
  //   );
  // FV要素
  const fvElement = document.querySelector(".js-fv-special2025");

  //要素があった時に処理を実行
  if (
    (special2025FixedElements.length > 0 ||
      special2025HeaderElements.length > 0) &&
    fvElement
  ) {
    // ヘッダーのクラスを制御する関数
    function scrollHeaderControl() {
      // FV要素の高さを取得
      let fvHeight = fvElement.offsetHeight;
      // ウィンドウの高さを取得（既存の固定要素用）
      let windowHeight = window.innerHeight;
      // ブラウザの上端からの縦方向ページのスクロール量
      let scroll = window.scrollY;

      // 固定要素の処理（FVの高さを基準に変更）
      special2025FixedElements.forEach(function (element) {
        if (scroll > fvHeight) {
          element.classList.add("is-visible");
        } else {
          element.classList.remove("is-visible");
        }
      });

      //   // ヘッダー要素の処理（新しい処理）
      //   special2025HeaderElements.forEach(function (element) {
      //     // スクロールが始まったら非表示
      //     if (scroll > 0 && scroll <= fvHeight) {
      //       element.classList.add("is-hidden");
      //       element.classList.remove("is-visible");
      //     }
      //     // FVを超えたら表示
      //     else if (scroll > fvHeight) {
      //       element.classList.add("is-visible");
      //       element.classList.remove("is-hidden");
      //     }
      //     // 最上部ではヘッダーを表示
      //     else {
      //       element.classList.add("is-visible");
      //       element.classList.remove("is-hidden");
      //     }
      //   });
    }

    // 初期状態の設定
    scrollHeaderControl();

    // スクロール時に実行
    window.addEventListener("scroll", scrollHeaderControl);

    // ウィンドウサイズが変更された場合も実行
    window.addEventListener("resize", scrollHeaderControl);
  }
});

//-----------------------------
// 下層ページの文字アニメーション。スクロールすると、画像が表示される
document.addEventListener("DOMContentLoaded", function () {
  // スクロールで表示するGIF要素を取得
  const scrollGifs = document.querySelectorAll(".scroll-gif");

  // Intersection Observerの設定
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 要素が画面に入ったとき
          const img = entry.target;

          // 元の画像のロードが完了するまで表示しない
          const originalSrc = img.getAttribute("data-src");
          const newSrc = originalSrc + "?t=" + new Date().getTime();

          // 画像のロードが完了したら表示する
          const tempImg = new Image();
          tempImg.onload = function () {
            img.src = newSrc;
            img.classList.add("visible");
          };
          tempImg.src = newSrc;
        }
      });
    },
    {
      threshold: 0.1, // 10%が見えたときに発火
    }
  );

  // 各GIF要素を監視
  scrollGifs.forEach((gif) => {
    observer.observe(gif);
  });
});

//-----------------------------
// 下層ページのvideo。スクロールすると、自動再生される
document.addEventListener("DOMContentLoaded", function () {
  // #autoplayVideo 要素の存在を確認
  const video = document.getElementById("autoplayVideo");

  // 要素が存在しない場合は処理を中止
  if (!video) {
    // console.log("#autoplayVideo の要素が見つからないため、自動再生処理をスキップします");
    return;
  }

  // Intersection Observerの設定
  const options = {
    root: null, // ビューポートをルートとして使用
    rootMargin: "0px",
    threshold: 0.5, // 50%が見えたら実行
  };

  // コールバック関数
  const handleIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // 画面内に入ったら再生
        video.play().catch((e) => {
          // console.log("自動再生できませんでした:", e);
          // 多くのブラウザでは、ユーザーインタラクションなしでの自動再生ポリシーがあります
          // ミュート状態であれば通常は問題ありません
        });
      } else {
        // 画面外に出たら一時停止
        video.pause();
      }
    });
  };

  // オブザーバーの作成と開始
  const observer = new IntersectionObserver(handleIntersection, options);
  observer.observe(video);
});

//-----------------------------
// スクロールでフェードインするアニメーション
document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".js-fadein-blur");
  // .js-fadein-blurが存在する場合のみ実行
  if (elements.length > 0) {
    // ページ読み込み時にファーストビュー内の要素に is-show を付与
    elements.forEach(function (element) {
      let fadeTop = Math.floor(element.getBoundingClientRect().top);
      const windowHeight = window.innerHeight;
      //要素がビューポートの高さの約95%（windowHeight / 1.05）以内にあればクラスつける
      if (windowHeight / 1.05 > fadeTop) {
        //少し遅延してからis-showを付与
        setTimeout(function () {
          element.classList.add("is-show");
        }, 120);
      }
    });
  }
});

window.addEventListener("scroll", function () {
  const elements = document.querySelectorAll(".js-fadein-blur");
  // .js-fadein-blurが存在する場合のみ実行
  if (elements.length > 0) {
    let scrollTop = window.pageYOffset;
    // スクロール時にフェードインする
    elements.forEach(function (element) {
      let fadeTop = Math.floor(element.getBoundingClientRect().top);
      let elementBottom = fadeTop + scrollTop; // 要素のtop位置 + スクロール位置

      // スクロール位置から、ビューポートの高さ95%の位置に要素が入ったらクラスを付与（500ms遅延）
      if (scrollTop + window.innerHeight / 1.05 > elementBottom) {
        setTimeout(function () {
          element.classList.add("is-show");
        }, 500);
      }
    });
  }
});

// スライダーにトップに戻るボタンを追加するJS
var getURL = location.pathname;
if (getURL.indexOf("pages/interview_") >= 0) {
  $('#interview-top-special2025__slider').addClass('child');
}
